import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
export function CTASection() {
  const {
    t
  } = useLanguage();
  const benefits = [t('cta.benefit1'), t('cta.benefit2'), t('cta.benefit3')];
  return <section id="contact" className="py-16 lg:py-24 bg-gradient-to-b from-[#0d1225] to-[#0a0e1a]" data-id="element-61">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="bg-gradient-to-br from-[#ff6b35]/20 to-[#ff6b35]/5 rounded-3xl border border-[#ff6b35]/30 p-8 lg:p-12 text-center" data-id="element-63">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-64">
            {t('cta.title')}
          </h2>

          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto" data-id="element-65">
            {t('cta.subtitle')}
          </p>

          {/* Benefits */}
          <div className="flex flex-wrap justify-center gap-4 lg:gap-8 mb-10" data-id="element-66">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-2" data-id="element-67">
                <CheckIcon className="w-5 h-5 text-[#ff6b35]" data-id="element-68" />
                <span className="text-gray-300" data-id="element-69">{benefit}</span>
              </div>)}
          </div>

          {/* CTA Button */}
          <button onClick={openCalendlyPopup} className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-10 py-5 rounded-xl font-semibold text-lg transition-all hover:scale-105" data-id="element-70">
            {t('cta.button')}
            <ArrowRightIcon className="w-5 h-5" data-id="element-71" />
          </button>
        </div>
      </div>
    </section>;
}